import React, { useState, useEffect } from 'react';
import './Controller.css'
import Swiper from 'swiper';
import 'swiper/css';
import Duplicator from './modes/Duplicator';
import Classifier, { PopupClassifier } from './modes/Classifier';
import PilarChooser from './modes/PilarChooser';
import FontResizer from './modes/FontResizer';
import LayerChooser from './modes/LayerChooser';
import BotoPestanya from './BotoPestanya'
import QuiTrepitja from './modes/QuiTrepijta';
import Escaletes from './modes/Escaletes';
import CordoSetter from './modes/cordons/CordoSetter';
import CordoModeSetter from './modes/cordons/CordoModeSetter';
import BotoPestanyaUp from '../pissarra/controller/botons/BotoPestanyaUp';
import BotoPestanyaDown from '../pissarra/controller/botons/BotoPestanyaDown';
import CaixaEraser from './modes/CaixaEraser';
import RotateText from './modes/RotateText';
import { postAPI } from '../../utils/utils';
import PomsClassifier, { PopupPomsClassifier } from './modes/PomsClassifier';
import EtiquetaModeSetter from './modes/etiquetes/EtiquetaModeSetter';
import EtiquetesSetter from './modes/etiquetes/EtiquetesSetter';
import { PopupEtiquetaChooser } from './modes/etiquetes/EtiquetaChooser';
import Pressable from '../other/Pressable';
import { TransformTools, BotoTransformModeSetter } from './TransformTools';
import PaintSetter from './modes/PaintSetter';

const formatName = name => name
    .replace(/[^a-zA-Z0-9_()-]/g, '')
    .toLowerCase();

const RESERVED_EDITOR_PATHS = ['new', 'crear', 'proves', 'plantilles', 'paperera', 'amagades', 'bundle'];

const getEditablePlantillaNameFromPath = () => {
    const urlName = window.location.pathname.split('/').filter(part => part !== '')[1];
    return urlName && !RESERVED_EDITOR_PATHS.includes(urlName) ? urlName : null;
};

const savePlantilla = ({ force=false, socket, plantillaDefaultName, jsonOutput, selectedCastellPart, setNotification, svg }) => {
    const existingPlantillaName = getEditablePlantillaNameFromPath();

    if (!existingPlantillaName) {
        const promptedName = window.prompt(
            `NOM DE LA PLANTILLA` + (force ? ` - (No el canviïs si vols sobreescriure-la, trobaràs l'antiga a l'apartat "Plantilles eliminades")` : ''),
            selectedCastellPart !== null ? formatName(selectedCastellPart) :
            plantillaDefaultName !== null ? formatName(plantillaDefaultName) :
            ''
        );

        if (promptedName === null) return false;

        const formattedName = formatName(promptedName.trim());
        if (!formattedName) {
            window.alert('Has d\'escriure un nom per guardar la plantilla.');
            return false;
        }

        postAPI('/save_svg', { name: formattedName, data: svg })
        socket.emit('.create_plantilla', formattedName, jsonOutput, force)
        return true;
    } else {
        postAPI(
            '/save_plantilla',
            { nom: formatName(existingPlantillaName), data: jsonOutput },
            data => console.log(data),
        );

        // socket.emit('.save_plantilla', formatName(urlName), jsonOutput, force)
        setNotification('✅ Guardat correctament')
        return true;
    }
}

const getCaixesFromJSON = (json, condition) => {
    return Object.fromEntries(
        Object.entries(json)
            .filter(el => el[1] && el[1].type === 'caixa')
            .filter(condition)
    )
}

const saveBundle = ({ socket, jsonOutput, addons, selectedBundle, bundleInfo, setNotification }) => {
    if (window.location.pathname === `/editor/bundle/new`) {
        // Doesn't exist
        return false;
    } else {
        const urlName = window.location.pathname.split('/').filter(part => part != '')[2];

        if (urlName) {

            const parts = Object.fromEntries(
                (Object.entries(bundleInfo?.parts) || [])
                    .map(([pestanya, plantilla]) => [
                        plantilla,
                        getCaixesFromJSON(jsonOutput,
                            ([id, caixa]) => caixa?.pestanya.toLowerCase() === pestanya.toLowerCase()
                        )
                    ])
            )

            socket.emit('.update_bundle_caixes', selectedBundle, parts)
            socket.emit('.update_bundle_addons', selectedBundle, addons)
            setNotification('✅ Guardat correctament')
            return true;
        }
    }

    return false;
}

function BotoSave(props) {
    const { socket, hasJSONChanged, setHasJSONChanged } = props;

    const save = () => {
        if (!props.selectedBundle) {
            const hasSaved = savePlantilla(props);
            if (hasSaved) setHasJSONChanged(0)
        } else {
            const hasSaved = saveBundle(props);
            if (hasSaved) setHasJSONChanged(0)
        }
    }

    useEffect(() => {
        const onDuplicatePlantilla = nom => {
            const forceSave = window.confirm(`Ja existeix una plantilla amb el nom ${nom}. Canvia-li el nom o sobreescriure-la.`)
            if (forceSave) savePlantilla({ ...props, plantillaDefaultName: nom, force: true })
        }
        socket.on('.duplicate_plantilla', onDuplicatePlantilla)

        const onCreatedPlantilla = nom => {
            window.location.href = `/editor/${nom}`;
        }
        socket.on('.created_plantilla', onCreatedPlantilla)

        return () => {
            socket.off('.duplicate_plantilla', onDuplicatePlantilla);
            socket.off('.created_plantilla', onCreatedPlantilla);
        }
    }, [])

    useEffect(() => {
        if (!props.popupClosed) return;

        const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;

        // Define a function for the 'keydown' event
        const handleKeyDown = (event) => {
            const modKey = isMac ? event.metaKey : event.ctrlKey;
            // If the key is Ctrl+S / Cmd+S, call savePlantilla
            if (!props.isFocused && modKey && (event.key === 'S' || event.key === 's')) {
                event.preventDefault()
                save()
            }
        }

        // Attach the event listener
        window.addEventListener('keydown', handleKeyDown);

        // Clean up function
        return () => {
            // Remove the event listener when the component is unmounted
            window.removeEventListener('keydown', handleKeyDown);
        }
    }, [props.isFocused, props, props.popupClosed]) // update the event listener every time props changes

    const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
    const shortcutLabel = isMac ? 'Cmd + S' : 'Ctrl + S';

    return (
        <Pressable className="boto" onClick={save}>
            <span role="img" aria-label="save">💾</span>
            <div style={{
                position: 'absolute',
                left: 12,
                backgroundColor: 'rgba(173, 216, 230, 0.7)', // lightblue with 70% transparency
                fontSize: 10,
                padding: 3,
                borderRadius: 5,
                color: 'rgba(0, 0, 0, 0.7)', // black font with 70% transparency
            }}>
                {shortcutLabel}
            </div>
        </Pressable>
    );
}

function Controller(props) {
    const { mode, selectedBundle, tabs, pestanya, setPestanya, socket, extended, setExtended, ajuntament, setAjuntament, castellerSelected, posicions, lastCaixes, caixaSelected, swiper, setSwiper, castell } = props;
    const [popupClosed, setPopupClosed] = useState(true);
    const [popupClosedPoms, setPopupClosedPoms] = useState(true);
    const [hasJSONChanged, setHasJSONChanged] = useState(-1);
    const [etiquetaToInput, setEtiquetaToInput] = useState(null);
    const [clipboard, setClipboard] = useState([]);

    useEffect(() => {
        setHasJSONChanged(prev => prev + 1)
    }, [
        JSON.stringify(props.json)
    ])

    useEffect(() => {
        setSwiper(new Swiper(".controllerSwiper", {
            threshold: 20,
            initialSlide: 0,
            allowTouchMove: true
        }));
    }, []);

    useEffect(() => {
        if (swiper) {
            swiper.on('transitionStart', function() {
                // If slide is not 0, extend
                setExtended(swiper.realIndex > 0)

                // Aesthetic change
                setTimeout(
                    () => {
                        document.querySelector('.activa')?.classList.remove('activa')
                        document.querySelector('.swiper-slide.swiper-slide-active').querySelector('.castellers-container')?.classList.add('activa')
                    },
                    50
                )
            });
        }
    }, [swiper])

    const noCaixaSelected = caixaSelected === -1;
    const isCaixaSelected = caixaSelected !== -1;

    return (
        <>
            <PopupEtiquetaChooser etiquetaToInput={etiquetaToInput} setEtiquetaToInput={setEtiquetaToInput} popupClosed={popupClosed} setPopupClosed={setPopupClosed} {...props} />
            <PopupPomsClassifier popupClosed={popupClosedPoms} setPopupClosed={setPopupClosedPoms} show={isCaixaSelected} {...props} />

            <div id="controller-container" className={`swiper controllerSwiper ${extended ? 'extended' : ''}`}>
                <div className="swiper-wrapper">
                    <div className="swiper-slide botons">
                        {
                            mode === 'cordons' ? <>
                                <CordoSetter show={true} {...props} />
                            </> : 
                            mode === 'etiquetes' ? <>
                                <EtiquetesSetter show={true} etiquetaToInput={etiquetaToInput} popupClosedPoms={popupClosedPoms} setPopupClosedPoms={setPopupClosedPoms} isCaixaSelected={isCaixaSelected} setEtiquetaToInput={setEtiquetaToInput} popupClosed={popupClosed} setPopupClosed={setPopupClosed} {...props} />
                            </> :
                            mode === 'transform' ? <>
                                <TransformTools
                                    selectedIds={props.selectedIds}
                                    json={props.json}
                                    setJsonOutput={props.setJsonOutput}
                                    caixaSelected={caixaSelected}
                                    setMode={props.setMode}
                                    undo={props.undo}
                                    redo={props.redo}
                                    canUndo={props.canUndo}
                                    canRedo={props.canRedo}
                                    setSelectedIds={props.setSelectedIds}
                                    setCaixaSelected={props.setCaixaSelected}
                                    pz={props.pz}
                                    clipboard={clipboard}
                                    setClipboard={setClipboard}
                                    submode={props.submode}
                                    setSubmode={props.setSubmode}
                                    snapEnabled={props.snapEnabled}
                                    setSnapEnabled={props.setSnapEnabled}
                                    pestanya={pestanya}
                                />
                            </> :
                            mode === 'paint' ? <>
                                <PaintSetter show={true} {...props} />
                            </> :
                            <>
                                {
                                    !selectedBundle && <>
                                        <BotoTransformModeSetter mode={mode} setMode={props.setMode} />
                                        <CaixaEraser show={isCaixaSelected} popupClosed={popupClosed} {...props} />
                                        <PilarChooser show={isCaixaSelected} popupClosed={popupClosed} {...props} />
                                        {/* <Classifier show={isCaixaSelected} popupClosed={popupClosed} setPopupClosed={setPopupClosed} {...props} /> */}
                                        <RotateText show={isCaixaSelected} popupClosed={popupClosed} {...props} />
                                    </>
                                }

                                <Duplicator show={isCaixaSelected} popupClosed={popupClosed} {...props} />

                                {
                                    selectedBundle && <>
                                        <QuiTrepitja show={isCaixaSelected} popupClosed={popupClosed} {...props} />
                                        <Escaletes show={isCaixaSelected} popupClosed={popupClosed} {...props} />
                                    </>
                                }

                                <FontResizer show={noCaixaSelected} {...props} />
                                <CordoModeSetter show={noCaixaSelected} {...props} />
                                <EtiquetaModeSetter show={noCaixaSelected} {...props} />
                                {noCaixaSelected ? (
                                    <Pressable className="boto" onClick={() => { props.setMode('paint'); props.setColorPopupClosed(false); }}>
                                        <span role="img" aria-label="color">🎨</span>
                                    </Pressable>
                                ) : null}
                            </>
                        }
                        
                        <BotoSave hasJSONChanged={hasJSONChanged} popupClosed={popupClosed} setHasJSONChanged={setHasJSONChanged} {...props} />
                        <BotoPestanyaUp show={selectedBundle} tabs={tabs} pestanya={pestanya} setPestanya={setPestanya} {...props} />
                        <BotoPestanyaDown show={selectedBundle} tabs={tabs} pestanya={pestanya} setPestanya={setPestanya} {...props} />
                    </div>
                </div>
            </div>
        </>
    );
}

export default Controller;
